import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import css from "./colour_picker.module.scss";

const colourMatrix = [
  ["#000000", "#434343", "#666666", "#999999", "#CCCCCC", "#EFEFEF", "#F3F3F3"],
  ["#EFA093", "#FFD6A2", "#FCE8B3", "#C6F3DE", "#C9DAF8", "#D0BCF1", "#FCDEE8"],
  ["#E66550", "#FFBC6B", "#FCDA83", "#68DFA9", "#6D9EEB", "#B694E8", "#FBC8D9"],
  ["#CC3A21", "#EAA041", "#F2C960", "#3DC789", "#3C78D8", "#8E63CE", "#E07798"],
  ["#AC2B16", "#CF8933", "#D5AE49", "#2A9C68", "#285BAC", "#653E9B", "#B65775"],
  ["#822111", "#A46A21", "#AA8831", "#1A764D", "#1C4587", "#41236D", "#83334C"]
];

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
const ColourBox = ({ colour, onClick, selected }) => (
  <div
    className={classNames(css.colourBox, { [css.selected]: selected })}
    style={{ background: colour }}
    onClick={() => onClick(colour)}
  />
);

ColourBox.propTypes = {
  colour: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool
};

const ColourPicker = ({ colours, onClick, selected, className }) => (
  <div className={className}>
    {colours.map((row) => (
      <div key={row[0]} className={css.row}>
        {row.map((column) => (
          <ColourBox key={column} colour={column} onClick={onClick} selected={selected === column} />
        ))}
      </div>
    ))}
  </div>
);

ColourPicker.propTypes = {
  colours: PropTypes.array,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.string,
  className: PropTypes.string
};

ColourPicker.defaultProps = {
  colours: colourMatrix
};

export default ColourPicker;
